'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { ChevronDown, ChevronUp, FileText } from 'lucide-react';
import Container from '../Container';

const faqs = [
  // {
  //   question: 'Who is Seozast designed for?',
  //   answer: (
  //     <>
  //       Seozast is designed for startups, bloggers, website owners, and marketing agencies looking to boost organic traffic with automated SEO content. From small blogs (Basic, 20 articles/month) to high-traffic platforms (Enterprise, 100 articles/month), Seozast adapts to your needs with one-click GitHub publishing.
  //     </>
  //   ),
  // },
  {
    question: 'What is AI Search Optimization (GEO)?',
    answer: (
      <>
        AI Search Optimization helps your content appear in AI-powered search platforms like ChatGPT, Perplexity, and Google SGE. As more people search using AI assistants, optimizing for these platforms becomes crucial for visibility. Learn more in our{' '}
        <Link href="/articles/geo-vs-seo" className="text-emerald-700 hover:underline">
          GEO vs. SEO guide
        </Link>.
      </>
    ),
  },
  // {
  //   question: 'How does Seozast help me grow my organic traffic?',
  //   answer: (
  //     <>
  //       Seozast generates SEO-optimized articles using manual or automated keywords. It includes automated scraping for relevant data, a dashboard to manage content, and one-click GitHub publishing. Pro and Enterprise plans offer priority support to maximize results.
  //     </>
  //   ),
  // },
  {
    question: 'How does SEOZast differ from other SEO tools?',
    answer: (
      <>
        SEOZast is the only tool that optimizes for both traditional search engines and AI search platforms. We also offer one-click GitHub deployment, multiple export formats, and all this at a fraction of the cost of traditional SEO tools at the most affordable price.
      </>
    ),
  },
  {
    question: 'What’s included in the subscription plan?',
    answer: (
      <>
        All plans include SEO and AI search article generation, a full dashboard, real-time analytics with Bing indexing, images from Pexels, and one-click publishing to GitHub, Webflow, WordPress and Shopify. Choose from:
        <ul className="mt-2 space-y-1 text-gray-500">
          <li className="flex items-start">
            <span className="text-emerald-700 mr-2">✓</span> Basic: 20 articles/month, 2 sites ($19.99/month)
          </li>
          <li className="flex items-start">
            <span className="text-emerald-700 mr-2">✓</span> Pro: 40 articles/month, 4 sites, priority support ($29.99/month)
          </li>
          <li className="flex items-start">
            <span className="text-emerald-700 mr-2">✓</span> Enterprise: 100 articles/month, 6 sites, priority support ($59.99/month)
          </li>
        </ul>
      </>
    ),
  },
  {
    question: 'Can I track my website performance with SEOzast?',
    answer: (
      <>
        Yes! SEOzast includes built-in <strong>real-time analytics</strong> powered by Umami. You can monitor page views, user activity, and engagement directly from your dashboard, helping you measure the impact of your AI-optimized articles.
      </>
    ),
  },
  // {
  //   question: 'Can I track my website performance with SEOzast?',
  //   answer: (
  //     <>
  //       Yes! SEOzast includes built-in <strong>real-time analytics</strong> powered by <a href="https://umami.is/" target="_blank" rel="noopener noreferrer" className="text-emerald-700 hover:underline">Umami</a>. You can monitor page views, user activity, and engagement directly from your dashboard, helping you measure the impact of your AI-optimized articles.
  //     </>
  //   ),
  // }
  {
    question: 'Can I export the articles for use elsewhere?',
    answer: (
      <>
        Yes, you can export generated articles as text, Word, or Markdown from the dashboard. Use them in your CMS (WordPress, Webflow, etc.) or other platforms without restrictions.
      </>
    ),
  },
  {
    question: 'Can I customize the articles or topics before generation?',
    answer: (
      <>
        Yes, change the automated keywords manually. Adjust topics and titles in the dashboard before generating articles. You can edit articles before publishing.
      </>
    ),
  },
  {
    question: 'Do I need technical skills to use Seozast?',
    answer: (
      <>
        No, Seozast is user-friendly with an intuitive dashboard and no technical skills required. Automation (scraping, keywords, backlinks) is preconfigured, and ypu can do everything in one click.
      </>
    ),
  },
  {
    question: 'Does Seozast support languages other than English?',
    answer: (
      <>
        Yes, Seozast supports multiple languages via AI integration. Generate content in 63 languages.
      </>
    ),
  },
  // {
  //   question: 'Do I fully own the articles and images created?',
  //   answer: (
  //     <>
  //       You fully own the articles generated by Seozast, and you can use them freely, provided they comply with applicable laws and do not infringe third-party rights. Images are sourced from Pexels under the <a href="https://www.pexels.com/license" target="_blank" rel="noopener noreferrer" className="text-emerald-700 underline hover:text-emerald-500">Pexels License</a>, which allows free use for personal and commercial purposes without attribution. However, you do not own the images, and certain restrictions apply (e.g., you cannot resell them as standalone products). Always review the Pexels License for details.
  //     </>
  //   ),
  // },
  // {
  //   question: 'Is the content original and free from plagiarism?',
  //   answer: (
  //     <>
  //       Seozast uses AI to generate original content, verified to avoid plagiarism. Automated scraping cleans and restructures data to ensure uniqueness.
  //     </>
  //   ),
  // },
  {
    question: 'Is there a free trial or sample content available?',
    answer: (
      <>
        We don’t offer a free trial, so we recommend starting with the Basic plan at $19.99/month. You can also view sample articles on our site or{' '}
        <a
          href="mailto:seozast@hotmail.com"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-emerald-700 hover:text-emerald-600"
        >
          contact us
        </a>{' '}
        for a personalized demo before subscribing.
      </>
    ),
  },
  // {
  //   question: 'What is GEO?',
  //   answer: (
  //     <>
  //       Generative Engine Optimization (GEO) is the process of optimizing content to be cited by AI-driven search platforms like ChatGPT, Perplexity, and Google SGE. Seozast now supports GEO, helping your articles rank on traditional search engines and appear in AI answers. Learn more in our{' '}
  //       <Link href="/articles/geo-vs-seo" className="text-emerald-700 hover:underline">
  //         GEO vs. SEO guide
  //       </Link>.
  //     </>
  //   ),
  // },
];

const FAQ = () => {
  const [openQuestionIndex, setOpenQuestionIndex] = useState<number | null>(null);

  const toggleQuestion = (index: number) => {
    setOpenQuestionIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="py-20 text-black">
      <Container>
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Frequently Asked Questions
        </h2>
        <div className="space-y-6 max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index}>
              <dt
                className={`text-lg font-semibold mb-2 flex justify-between items-center cursor-pointer ${openQuestionIndex === index ? 'text-emerald-600' : 'text-black'
                  }`}
                onClick={() => toggleQuestion(index)}
              >
                <span>{faq.question}</span>
                {openQuestionIndex === index ? (
                  <ChevronUp size={20} />
                ) : (
                  <ChevronDown size={20} />
                )}
              </dt>
              {openQuestionIndex === index && (
                <dd className="text-sm sm:text-md text-black leading-relaxed">
                  {faq.answer}
                </dd>
              )}
            </div>
          ))}
          <p className="text-center pt-10">
            Have another question?{' '}
            <a
              href="mailto:seozast@hotmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-emerald-700 hover:text-emerald-600"
            >
              Contact us
            </a>.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default FAQ;